module.exports = __webpack_public_path__ + "img/nm_home_teaser1_illustration.25c67860.png";